export const version = "ethers/5.5.2";
//# sourceMappingURL=_version.js.map